import axios from 'axios';
import { Config } from 'config';
import { IInstallmentAgreementRequest } from './MonthlyPaymentContract.types';

const url = `${Config.url.CART_URL}/api/v1/Installment`;

export const SaveMonthlyContracts = (request: IInstallmentAgreementRequest) => {
    axios.post<IInstallmentAgreementRequest>(url, request).then(
        (e) => console.log(e),
        (e) => console.log(e)
    );
};
